var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"usa-layout-docs__sidenav desktop:grid-col-3"},[_c('nav',{attrs:{"aria-label":"topics"}},[_c('ul',{staticClass:"usa-sidenav usa-list--unstyled"},_vm._l((_vm.data.fields.leftMenuItemReferences),function(step,i){return _c('document-renderer',{key:i,attrs:{"documentId":step.sys.id}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }